<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-calendar"></i> 稽查管理
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <h4>{{ $route.meta.title }}</h4>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="handle-box">
        <el-form ref="searchform" :model="searchform" label-width="120px" @keyup.enter.native="search()">
          <el-row>
            <el-col :span="6">
              <el-form-item label="产品编码" prop="productCode">
                <el-select v-model="searchform.productCode" placeholder="请输入产品名称模糊匹配或者下拉选择" style="width:100%"
                  :remote-method="getproductlist" filterable remote :loading="productloading" :disabled="show">
                  <el-option v-for="item in productlist" :key="item.product_code" :label="item.product"
                    :value="item.product_code" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="码" prop="qrcode">
                <el-input v-model="searchform.qrcode" style="width:100%" clearable placeholder="请输入码" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="生产批次" prop="batchno">
                <el-input v-model="searchform.batchno" style="width:100%" clearable placeholder="请输入生产批次" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="经销商编码" prop="dealerCode">
                <el-input v-model="searchform.dealerCode" style="width:100%" clearable placeholder="请输入经销商编码" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="经销商名称" prop="dealerName">
                <el-input v-model="searchform.dealerName" style="width:100%" clearable placeholder="请输入经销商名称" />
              </el-form-item>
            </el-col>
            <!-- <el-col :span="6">
              <el-form-item label="稽查时间" prop="datelist">
                <el-date-picker style="width:100%" v-model="searchform.datelist" type="daterange"
                  value-format="yyyy-MM-dd HH:mm:ss" range-separator="-" start-placeholder="开始日期"
                  end-placeholder="结束日期">
                </el-date-picker>
              </el-form-item>
            </el-col> -->
            <el-col :span="6">
              <el-form-item label="系统判断" prop="statusSystem">
                <el-select v-model="searchform.statusSystem" placeholder="系统判断">
                  <el-option label="未判断" :value="0"></el-option>
                  <el-option label="正常" :value="1"></el-option>
                  <el-option label="窜货" :value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="手工系统" prop="statusUser">
                <el-select v-model="searchform.statusUser" placeholder="手工系统">
                  <el-option label="未判断" :value="0"></el-option>
                  <el-option label="正常" :value="1"></el-option>
                  <el-option label="窜货" :value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="最终判断" prop="statusEnd">
                <el-select v-model="searchform.statusEnd" placeholder="最终判断">
                  <el-option label="未判断" :value="0"></el-option>
                  <el-option label="正常" :value="1"></el-option>
                  <el-option label="窜货" :value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8" :offset="1">
              <el-button @click="resetForm('searchform')">重置</el-button>
              <el-button type="primary" icon="el-icon-search" @click="searchform.page = 1, search()"
                v-permission="['inspectrecord_select']">搜索
              </el-button>
              <el-button :loading="downloadLoading" type="primary" icon="document"
                @click="handleDownload">导出Excel</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <br>
      <getForensicsimg ref="Forensicsimg"></getForensicsimg>
      <el-row type="flex" class="row-bg">
        <el-col :span="24" class="border">
          <h4>{{ $route.meta.title }}</h4>
          <el-divider></el-divider>
          <el-table border v-loading="listLoading" element-loading-text="拼命加载中" :data="tableData" style="width:100%;"
            id="parent">
            <el-table-column prop="userName" label="稽查人员" min-width="80" show-overflow-tooltip></el-table-column>
            <el-table-column prop="freightBillCode" label="出库单号" min-width="80" show-overflow-tooltip></el-table-column>
            <el-table-column prop="product" label="产品" min-width="250" show-overflow-tooltip></el-table-column>
            <el-table-column prop="batchno" label="生产批次" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column prop="qrcode" label="码" min-width="150" show-overflow-tooltip></el-table-column>
            <el-table-column prop="dealerCode" label="经销商编码" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column prop="dealerName" label="经销商名称" min-width="160" show-overflow-tooltip></el-table-column>
            <el-table-column prop="freightBillCodeTime" label="出库时间" min-width="160" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="workorderenterprisename" label="生产企业" min-width="160"
              show-overflow-tooltip></el-table-column>
            <el-table-column prop="factoryName" label="生产工厂" min-width="160" show-overflow-tooltip></el-table-column>
            <el-table-column prop="worklineName" label="生产产线" min-width="160" show-overflow-tooltip></el-table-column>
            <el-table-column prop="fromWarehouse" label="发货仓库" min-width="160" show-overflow-tooltip></el-table-column>
            <el-table-column prop="toWarehouse" label="收货仓库" min-width="190" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="remark" label="备注" min-width="190" show-overflow-tooltip></el-table-column>
            <el-table-column prop="statusSystem" label="系统判断" min-width="120" show-overflow-tooltip fixed="right">
            </el-table-column>
            <el-table-column prop="statusSystemTime" label="系统判断时间" min-width="160" show-overflow-tooltip
              fixed="right" />
            <el-table-column prop="statusUser" label="人工判断" min-width="120" show-overflow-tooltip fixed="right">
            </el-table-column>
            <el-table-column prop="statusUserTime" label="人工判断时间" min-width="160" show-overflow-tooltip fixed="right" />
            <el-table-column prop="statusEnd" label="最终判断" min-width="120" show-overflow-tooltip fixed="right">
              <template slot-scope="scope">
                <div>{{
                  scope.row.statusEnd }}
                  <el-button @click="TostatusEnd(scope.row)" plan icon="el-icon-edit" type="text"> 修改</el-button>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="statusEndTime" label="最终判断时间" min-width="160" show-overflow-tooltip fixed="right" />
            <el-table-column prop="" label="操作" min-width="120" show-overflow-tooltip fixed="right"> <template
                slot-scope="scope">

                <el-button @click="$refs.Forensicsimg.Tabledata(scope.row.qrcode)" plan type="text">
                  查看取证图片</el-button>

              </template>
            </el-table-column>
          </el-table>

          <br />
          <el-pagination background @current-change="currentchange" @size-change="limit"
            :current-page.sync="currentPage" :page-sizes="[10, 20, 30, 50]"
            layout="total,prev, pager, next,jumper,sizes" :total="total_count"></el-pagination>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { qrcodescaninspectleveltwolist, qrcodescaninspectleveltwoupdate } from "@/api/physical";
import getForensicsimg from "./components/getForensicsimg";
import { productlist } from "@/api/base";
export default {
  components: { getForensicsimg },
  mounted() {
    //请求部门列表数据并且便利到表格
    const timeOne = new Date()
    console.log(timeOne.getFullYear().toString(), '时间啊！！！！！！！！！！')
    this.$set(this.searchform, 'year', timeOne.getFullYear().toString())
    this.search();
    this.getproductlist();

  },
  data() {
    return {
      //基础数据
      listLoading: false,
      depart_uuid: [],
      tableData: [],
      //产品列表下拉
      productloading: false,
      show: false,
      productlist: [],
      //分页数据
      limits: "",
      total_count: 1,
      currentPage: 1,
      //导出表格变量
      tableDataDownload: [],
      downloadLoading: false,
      autoWidth: true,
      bookType: "xlsx",
      //搜索表单数据
      pickerOptions: {
        //disabled为函数，返回值为布尔值，
        // disabledDate: (time) => {
        //   let minYear = new Date().getFullYear()
        //   return time > Date.now() || time.getTime() < new Date(JSON.stringify(minYear))
        // }
      },
      searchform: {
        year: '',
        accountName: null,
        batchno: null,
        qrcode: null,
        datelist: [],
        screateTime: null,
        ecreateTime: null,
        productCode: null,
        page: 1,
        limit: 10
      }
    };
  },
  methods: {
    // 判断是否窜货
    TostatusEnd(row) {
      this.$confirm('最终判断是否窜货', '提示', {
        confirmButtonText: '窜货',
        cancelButtonText: '正常',
        distinguishCancelAndClose: true,
        type: 'warning'
      }).then(() => {
        qrcodescaninspectleveltwoupdate({
          "statusEnd": 2,
          "webId": row.webId
        }).then(response => {
          if (response.status_code == 200) {
            this.$message({
              type: "success",
              message: "提交成功!",
            });
            this.search();
          }
        })
      }).catch((action) => {
        if (action == 'cancel') {
          qrcodescaninspectleveltwoupdate({
            "statusEnd": 1,
            "webId": row.webId
          }).then(response => {
            if (response.status_code == 200) {
              this.$message({
                type: "success",
                message: "提交成功!",
              });
              this.search();
            }
          })
        } else {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        }

      });
    },
    // 获取产品下拉
    getproductlist(value) {
      this.productlist = [];
      if (value !== "") {
        this.productloading = true;
        setTimeout(() => {
          this.productloading = false;
          productlist({ productName: value }).then(response => {
            this.productlist = response.data.data;
            for (var i = 0; i < this.productlist.length; i++) {
              this.productlist[i].product =
                this.productlist[i].product_code +
                "   " +
                this.productlist[i].product_name;
            }
          });
        }, 200);
      } else {
        this.productlist = [];
      }
    },
    //请求表格数据
    Tabledata(obj) {
      this.listLoading = true;
      this.searchform.screateTime = this.searchform.datelist == null ? null : this.searchform.datelist[0],
        this.searchform.ecreateTime = this.searchform.datelist == null ? null : this.searchform.datelist[1],
        qrcodescaninspectleveltwolist(this.searchform).then(response => {
          this.packdate(response.data.list);
          this.tableData = response.data.list;
          this.total_count = response.data.totalCount;
          this.currentPage = response.data.currPage;
          this.listLoading = false;
          console.log(this.tableData)
        });
    },
    packdate(obj) {
      for (let i = 0; i < obj.length; i++) {
        switch (obj[i].statusSystem) {
          case 0: obj[i].statusSystem = "未判断"
            break;
          case 1: obj[i].statusSystem = "正常"
            break;
          case 2: obj[i].statusSystem = "窜货"
            break;
          default:
            break;
        }
        switch (obj[i].statusUser) {
          case 0: obj[i].statusUser = "未判断"
            break;
          case 1: obj[i].statusUser = "正常"
            break;
          case 2: obj[i].statusUser = "窜货"
            break;
          default:
            break;
        }
        switch (obj[i].statusEnd) {
          case 0: obj[i].statusEnd = "未判断"
            break;
          case 1: obj[i].statusEnd = "正常"
            break;
          case 2: obj[i].statusEnd = "窜货"
            break;
          default:
            break;
        }
        obj[i].province = (obj[i].provinceCodeSell || " ") + (obj[i].cityCodeSell || " ")
        obj[i].queryprovince = (obj[i].provinceCodeScan || " ") + (obj[i].cityCodeScan || " ")
        obj[i].product = (obj[i].productCode || " ") + (obj[i].productName || " ")
      }
    },

    //搜索事件
    search() {
      this.Tabledata();
    },
    //重置按钮
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    //分页跳转事件
    currentchange(page) {
      this.searchform.page = page
      this.Tabledata();
      console.log(page)
    },
    //分页每页显示条数事件
    limit(limit) {
      this.searchform.limit = limit
      this.search()
    },
    //导出表格事件
    handleDownload() {
      this.downloadLoading = true;
      let obj = this.searchform;
      obj.page = 1;
      obj.limit = this.total_count;
      qrcodescaninspectleveltwolist(obj).then(response => {
        this.packdate(response.data.list)
        this.tableDataDownload = response.data.list;
        console.log(this.tableDataDownload);
        import("@/vendor/Export2Excel").then(excel => {
          const tHeader = [
            "稽查人员",
            "出库单号",
            "产品",
            "生产批次",
            "码",
            "经销商编码",
            "经销商名称",
            "出库时间",
            "生产企业",
            "生产工厂",
            "生产产线",
            "发货仓库",
            "收货仓库",
            "备注",
            "系统判断",
            "系统判断时间",
            "人工判断",
            "人工判断时间",
            "最终判断",
            "最终判断时间",
          ];
          const filterVal = [
            "userName",
            "freightBillCode",
            "product",
            "batchno",
            "qrcode",
            "dealerCode",
            "dealerName",
            "freightBillCodeTime",
            "workorderenterprisename",
            "factoryName",
            "worklineName",
            "fromWarehouse",
            "toWarehouse",
            "remark",
            "statusSystem",
            "statusSystemTime",
            "statusUser",
            "statusUserTime",
            "statusEnd",
            "statusEndTime",
          ];
          const list = this.tableDataDownload;
          const data = this.formatJson(filterVal, list);
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: this.$route.meta.title,
            autoWidth: this.autoWidth,
            bookType: this.bookType
          });
          this.downloadLoading = false;
        });
      }); // hear
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          if (j === "timestamp") {
            return parseTime(v[j]);
          } else {
            return v[j];
          }
        })
      );
    },
    //跳转页面
    tiaozhuan() {
      this.$router.push({
        path: "/staffedit"
      });
    }
  }
};
</script>
<style scoped>
.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 10px 0;
}

.border {
  padding: 10px 10px;
  border-radius: 3px;
  border: 1px solid #e6ebf5;
  background-color: #fff;
  overflow: hidden;
  color: #303133;
  -webkit-transition: 0.3s;
  transition: 0.3s;
}

.handle-box {
  margin-bottom: 0px;
}

.handle-input {
  width: 160px;
  display: inline-block;
}

.del-dialog-cnt {
  font-size: 16px;
  text-align: center;
}

.mr10 {
  margin-right: 10px;
}

#parent {
  text-align: center;
}
</style>